import React from "react"
import Topic from "../../base-pages/topic"

const TopicCN = () => {
  return <Topic lang="cn" />
}

export default TopicCN
